import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('Token de verificação não fornecido');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.post('/api/auth/verify-email', { token });
        
        if (response.data.success) {
          setVerified(true);
          toast.success('Email verificado com sucesso!');
          // Redirecionar para login após 3 segundos
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setError(response.data.message || 'Erro ao verificar email');
        }
      } catch (error) {
        console.error('Erro na verificação:', error);
        setError(error.response?.data?.message || 'Erro ao verificar email. Token inválido ou expirado.');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="page page-center">
      <div className="container container-tight py-4">
        <div className="text-center mb-4">
          <a href="/" className="navbar-brand navbar-brand-autodark">
            <img src="https://preview.tabler.io/static/logo.svg" height="36" alt="" />
          </a>
        </div>
        <div className="card card-md">
          <div className="card-body text-center py-4 p-sm-5">
            {loading ? (
              <>
                <div className="spinner-border text-primary mb-3" role="status"></div>
                <h1 className="mt-5">Verificando seu email...</h1>
                <p className="text-muted">Por favor, aguarde enquanto verificamos seu email.</p>
              </>
            ) : verified ? (
              <>
                <span className="avatar avatar-xl mb-3 bg-success-lt">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 12l5 5l10 -10"></path>
                  </svg>
                </span>
                <h1 className="mt-5">Email verificado com sucesso!</h1>
                <p className="text-muted">Seu email foi verificado com sucesso. Você será redirecionado para a página de login em alguns segundos.</p>
                <div className="mt-4">
                  <Link to="/login" className="btn btn-primary w-100">
                    Ir para Login
                  </Link>
                </div>
              </>
            ) : (
              <>
                <span className="avatar avatar-xl mb-3 bg-danger-lt">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-alert-triangle" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M12 9v2m0 4v.01"></path>
                    <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"></path>
                  </svg>
                </span>
                <h1 className="mt-5">Erro na verificação</h1>
                <p className="text-muted">{error || 'Ocorreu um erro ao verificar seu email. O link pode estar expirado ou ser inválido.'}</p>
                <div className="mt-4">
                  <Link to="/login" className="btn btn-primary w-100">
                    Voltar para Login
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="text-center text-muted mt-3">
          Já tem uma conta? <Link to="/login" tabIndex="-1">Faça login</Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail; 